// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var SurveyView$ReactHooksTemplate = require("./SurveyView.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var ApplicationSettings$ReactHooksTemplate = require("../general_settings/applicationSettings.res.js");

function SurveyPreviewWrapper(props) {
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsx(SurveyView$ReactHooksTemplate.make, {
                        survey: props.survey,
                        client: props.client,
                        transactionStatus: "open",
                        surveyLanguages: /* [] */0,
                        language: SurveyLanguage$ReactHooksTemplate.default,
                        customerInfo: CustomerInfo$ReactHooksTemplate.empty(),
                        preview: true,
                        token: "",
                        applicationSettings: ApplicationSettings$ReactHooksTemplate.empty(),
                        currentPage: 1,
                        substitutionVariables: {}
                      }))
            });
}

var make = SurveyPreviewWrapper;

exports.make = make;
/* react/jsx-runtime Not a pure module */
